/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { SovrenOutputValidityCode } from '../enums/sovren-output-validity-code';
import { SovrenParsingStatus } from '../enums/sovren-parsing-status';
import { CandidateEntity } from './candidate-entity';
export class CandidateSovrenEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  parseStatus: SovrenParsingStatus | null = null;
  response: Record<string, unknown> | null = null;
  updatedAt: string | null = null;
  validityCode: SovrenOutputValidityCode | null = null;
  static override key = 'CandidateSovren';
  static override get schema() {
    return {
      candidate: CandidateEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateSovren' in input
    ) {
      const { CandidateSovren: wrapped, ...rest } = input as {
        CandidateSovren: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}